import { Button } from '@pepper/ui'
import { Icon } from '@iconify/react'

import DraftBannerArtwork from 'assets/images/draft_banner_artwork.png'

import s from './DraftBanner.module.css'

type Props = {
  onShowAllDrafts: () => void
  totalDrafts: number
}

const DraftBanner = ({ totalDrafts, onShowAllDrafts }: Props) => {
  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className={s.image}>
          <img src={DraftBannerArtwork} alt="banner" />
        </div>
        <div className={s.info}>
          <h4 className={s.heading}>{totalDrafts} items saved as draft</h4>
          <p>
            These items will be assigned to creators once you complete the
            brief.
          </p>
        </div>
        <div className={s.actions}>
          <Button type="ghost" onClick={onShowAllDrafts}>
            See all Drafts
            <Icon icon="lucide:chevron-right" />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DraftBanner
